import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import {GlobalsService} from "@services/globals.service";
import { Router} from "@angular/router";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InterceptorGuard implements CanActivate {
  constructor(private _globals: GlobalsService, private router: Router) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.validate()

  }

  validate = ()=> {
    if (this._globals.token) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }

}
